module.exports = __webpack_public_path__ + "static/media/ic-callkit-end.cd04e2c4.webp";